// extracted by mini-css-extract-plugin
export default {"popper-frame":"Popper_popper-frame__GFkro","fadeIn":"Popper_fadeIn__zloo2"};